import React, { useEffect, useState } from 'react';
import FormControl from '@mui/material/FormControl';
import { Container, TextField, Select, Typography, Box } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import { t } from 'i18next';
import { useForm } from 'react-hook-form';
import Cookies from 'js-cookie';
import { useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';
import LoadingButton from '@mui/lab/LoadingButton';
import axios from 'axios';
import currencies from '../../data/currencies';
import Navbar from '../../components/Navbar';
import { useLevels } from '../../hooks/useLevels';
import Loading from '../../components/Loading';
import { useCurriculums } from '../../hooks/useCurriculums';
import { useClasses } from '../../hooks/useClasses';
import { useDropzone } from "react-dropzone";
import { CloudUpload as CloudUploadIcon } from '@mui/icons-material';

function AddResources() {
  const lang = Cookies.get("i18next") || "en";
  const [levels, setLevels] = useState([])
  const [subjects, setSubjects] = useState([])
  const { data, isLoading } = useLevels()
  const { enqueueSnackbar } = useSnackbar();
  const [resource, setResource] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { teacher } = useSelector((state) => state.teacher);
  const { data: Curriculums } = useCurriculums()
  const { data: Classes } = useClasses()
  const Classrooms = [
    { id: "First semester", label: t("First semester") },
    { id: "Second semester", label: t("First semester") }
  ]
  const [fileImageName, setFileImageName] = useState('');
  const [Image, setImage] = useState();
  const [fileName, setFileName] = useState('');
  const [file, setFile] = useState(null);
  
  useEffect(() => {
    if (data?.data) {
      setLevels(data.data);
    }
    const getSubjects = async () => {
      const response = await axios.get(`${process.env.REACT_APP_API_KEY}api/v1/subject/allSubjects`);
      setSubjects(response.data.data);
    };
    getSubjects();
  }, [data]);

  const { register, handleSubmit, formState: { errors } } = useForm({
    subject: '',
    level: '',
    resource: '',
    classId: '',
    semester: '',
    curriculums: '',
    price: '',
    currency: '',
    teacherId: '',
    startDate: '',
    endDate: '',
    duration: '',
    linkResource: ""
  });

    const { getRootProps: getRootPropsImage, getInputProps: getInputPropsImage } = useDropzone({
      onDrop: (acceptedFiles) => handleFileUpload(acceptedFiles),  // عند اختيار الصورة
      accept: 'image/*'  // تحديد أن نوع الملف المسموح به هو الصور
    });
      const { getRootProps: getRootPropsFile, getInputProps: getInputPropsFile } = useDropzone({
        onDrop: (acceptedFiles) => handleFile(acceptedFiles),  // عند اختيار المستند
        accept: '.pdf,.doc,.docx,.ppt,.pptx,.txt'  // تحديد أن نوع الملف المسموح به هو المستندات
      });
    // هذه دالة التعامل مع صورة
    const handleFileUpload = (files) => {
      if (files && files[0]) {
        setFileImageName(files[0].name);  // تخزين اسم الصورة
        setImage(files[0]);
  
      }
    };
      // هذه دالة التعامل مع المستند
  const handleFile = (files) => {
    if (files && files[0]) {
      setFileName(files[0].name);  // تخزين اسم المستند
      setFile(files[0]);

    }
  };

  async function createResources(data) {
    const startDateTime = new Date(data.startDate); // تحويل إلى كائن تاريخ
    const endDateTime = new Date(data.endDate); // تحويل إلى كائن تاريخ
    const differenceInMilliseconds = endDateTime - startDateTime;
    const differenceInSeconds = Math.floor(differenceInMilliseconds / (1000 * 60 * 60 * 24));
    // تحقق من أن startDate أقل من endDate
    if (startDateTime >= endDateTime) {
      enqueueSnackbar(t("Start date must be earlier than end date"), { variant: "error", autoHideDuration: 5000 });
      return; // إنهاء الوظيفة إذا كان الشرط غير محقق
    }
    data.duration=differenceInSeconds
    data.startDate = startDateTime;
    data.endDate = endDateTime;
    const tmpData = { ...data, teacherId: teacher.id };
    const formData = new FormData();
    formData.append("image", Image);
    formData.append("docs", file);
    for (const key in tmpData) {
      formData.append(key, tmpData[key]);
    }
    try {
      await axios.post(`${process.env.REACT_APP_API_KEY}api/v1/resources/create-resource`, formData);
      setLoading(true);
      enqueueSnackbar(t("packageMsg"), { variant: "success", autoHideDuration: "5000" });
      navigate("/teacher/resources")
    } catch (err) {
      enqueueSnackbar("data failed", { variant: "error", autoHideDuration: "5000" });
      setLoading(false);
      throw new Error("Something went wrong's " + err);
    }
  }

  return (
    <Navbar>
      <Container sx={{ marginTop: '120px', marginBottom: '80px' }}>
        {(!isLoading) ? <>
          <h1 className="text-3xl text-center my-4">{t("addResource")}</h1>
          <form style={{  margin: 'auto' }} encType="multipart/form-data" onSubmit={handleSubmit(createResources)}>
            <FormControl fullWidth margin="dense">
              <InputLabel id="level">{t("subject")}</InputLabel>
              <Select
                labelId="subject"
                label={t("subject")}
                defaultValue="" // قيمة افتراضية
                {...register("subject", {
                  required: t("isRequired"),
                })}
              >
                {lang === "ar"
                  ? subjects.map((subject, index) => (
                    <MenuItem key={index} value={subject.id}>{t(subject.titleAR)}</MenuItem>
                  ))
                  : subjects.map((subject, index) => (
                    <MenuItem key={index} value={subject.id}>{t(subject.titleEN)}</MenuItem>
                  ))
                }
              </Select>
              <p className="text-red-500">{errors.subject?.message}</p>
            </FormControl>
            <FormControl fullWidth margin="dense">
              <InputLabel id="level">{t("choosesLevel")}</InputLabel>
              <Select
                labelId="level"
                label={t("choosesLevel")}
                defaultValue="" // قيمة افتراضية
                {...register("level", {
                  required: t("isRequired"),
                })}
              >
                {lang === "ar"
                  ? levels.map((level, index) => (
                    <MenuItem key={index} value={level.id}>{t(level.titleAR)}</MenuItem>
                  ))
                  : levels.map((level, index) => (
                    <MenuItem key={index} value={level.id}>{t(level.titleEN)}</MenuItem>
                  ))
                }
              </Select>
              <p className="text-red-500">{errors.level?.message}</p>
            </FormControl>

          <FormControl fullWidth margin="dense">
            <InputLabel id="classes">{t("classes")}</InputLabel>
            <Select
              labelId="classId"
              label={t("classes")}
              defaultValue="" // قيمة افتراضية
              {...register("classId", {
                required: t("isRequired"),
              })}
            >
              {
                Classes?.data.map((calss, index) => (
                  <MenuItem key={index} value={calss.id}>{lang === "ar" ? calss.titleAR : calss.titleEN}</MenuItem>
                ))
              }
            </Select>
            <p className="text-red-500">{errors.level?.message}</p>
          </FormControl>

          <FormControl fullWidth margin="dense">
            <InputLabel id="Curriculums">{t("studyCurriculum")}</InputLabel>
            <Select
              labelId="curriculums"
              label={t("curriculums")}
              defaultValue="" // قيمة افتراضية
              {...register("curriculums", {
                required: t("isRequired"),
              })}
            >
              {
                Curriculums?.data.map((Curriculum, index) => (
                  <MenuItem key={index} value={Curriculum.id}>{lang === "ar" ? Curriculum.titleAR : Curriculum.titleEN}</MenuItem>
                ))
              }
            </Select>
            <p className="text-red-500">{errors.level?.message}</p>
          </FormControl>
          <FormControl fullWidth margin="dense">
            <InputLabel sx={{ marginBottom: "6px", fontSize: "14px" }} id="semester">
              {t("semester")}
            </InputLabel>
            <Select
              labelId="semester"
              label={t("semester")}
              {...register("semester", {
                required: t("isRequired"),
              })}
            >
              {Classrooms?.length > 0 ? (
                Classrooms.map((semester, index) => (
                  <MenuItem key={index} value={semester.id}>
                    {t(semester.id)}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>{t("noData")}</MenuItem>
              )}
            </Select>
          </FormControl>

            <FormControl fullWidth margin="dense">
              <InputLabel id="resource">{t("resource")}</InputLabel>
              <Select
                onClick={() => setResource(true)}
                labelId="resource"
                label={t("resource")}
                {...register("resource", {
                  required: t("isRequired"),
                })}
              >
                <MenuItem value="Lecture">{t("Lecture")}</MenuItem>
                <MenuItem value="Exam">{t("Exam")}</MenuItem>
                <MenuItem value="Reviews">{t("Reviews")}</MenuItem>
                <MenuItem value="Summary of the material">{t("Summary of the material")}</MenuItem>
              </Select>
              <p className='text-red-500'>{errors.resource?.message}</p>
            </FormControl>
            <FormControl fullWidth margin="dense">
              <TextField
                label={t("startDate")}
                type="date"
                variant="outlined"
                {...register("startDate", {
                  required: t("isRequired"),
                })} />
              <p className='text-red-500'>{errors.startDate?.message}</p>
            </FormControl>
            <FormControl fullWidth margin="dense">
              <TextField
                label={t("End Date")}
                type="date"
                variant="outlined"
                {...register("endDate", {
                  required: t("isRequired"),
                })} />
              <p className='text-red-500'>{errors.endDate?.message}</p>
            </FormControl>
            <FormControl fullWidth margin="dense">
              <TextField
                label={t("price")}
                type="number"
                variant="outlined"
                {...register("price", {
                  required: t("isRequired"),
                })} />
              <p className='text-red-500'>{errors.price?.message}</p>
            </FormControl>
            <FormControl fullWidth margin="dense">
              <InputLabel id="currency">{t("currency")}</InputLabel>
              <Select
                labelId="currency"
                label={t("currency")}
                {...register("currency", {
                  required: t("isRequired"),
                })}
              >
                {
                  currencies.map((curr) => {
                    return <MenuItem value={curr.title}>{lang === "en" ? curr.titleEn : curr.titleAr}</MenuItem>
                  })
                }
              </Select>
              <p className='text-red-500'>{errors.currency?.message}</p>
            </FormControl>

            <Box sx={{ marginBottom: "18px" }}>
            <InputLabel sx={{ marginBottom: "6px", fontSize: "14px" }}>
              {t("Resource link (if you do not include documents related to the Resource, you must include a link to the Resource)")}
            </InputLabel>

            <FormControl fullWidth margin='dense'>
              <TextField type="text"  {...register("linkResource", {
                required: {
                  // value: !file,
                  message: t("file_video-validation")
                },
                pattern: {
                  value: /^(https?:\/\/)?(www\.youtube\.com|youtu\.be)\/.+$/,
                  message: t("youtube_link")
                }
              })} />

              <p className='text-red-500'>{errors.linkResource?.message}</p>
            </FormControl>
          </Box>
          <Box sx={{  maxWidth: "100%" }}>
            <Box sx={{ marginBottom: "18px" }}>
              <InputLabel sx={{ marginBottom: "6px", fontSize: "14px", fontWeight: 'bold', color: '#333' }}>
                {t("Resource documents")}
              </InputLabel>
              <div {...getRootPropsFile()} style={{
                border: '2px dashed #1976d2',
                padding: '20px',
                textAlign: 'center',
                cursor: 'pointer',
                borderRadius: '4px'
              }}>
                <input {...getInputPropsFile()} />
                <CloudUploadIcon sx={{ fontSize: "30px", color: "#1976d2" }} />
                <Typography sx={{ fontSize: "14px", color: "#1976d2", marginTop: "8px" }}>
                  {t("Resource documents")}
                </Typography>
              </div>

              {/* عرض اسم المستند بعد اختياره */}
              {fileName && (
                <Typography sx={{ marginTop: "10px", fontSize: "17px", color: "red", textAlign: "center" }}>
                  {t("Selected File")}: {fileName}
                </Typography>
              )}
            </Box>

            <Box sx={{ marginBottom: "18px" }}>
              <InputLabel sx={{ marginBottom: "6px", fontSize: "14px", fontWeight: 'bold', color: '#333' }}>
                {t("Choose a suitable image for the resource")}
              </InputLabel>
              <div {...getRootPropsImage()} style={{
                border: '2px dashed #1976d2',
                padding: '20px',
                textAlign: 'center',
                cursor: 'pointer',
                borderRadius: '4px'
              }}>
                <input {...getInputPropsImage()} />
                <CloudUploadIcon sx={{ fontSize: "30px", color: "#1976d2" }} />
                <Typography sx={{ fontSize: "14px", color: "#1976d2", marginTop: "8px" }}>
                  {t("Choose a suitable image for the resource")}
                </Typography>
              </div>

              {/* عرض اسم الصورة بعد اختياره */}
              {fileImageName && (
                <Typography sx={{ marginTop: "10px", fontSize: "17px", color: "red", textAlign: "center" }}>
                  {t("selected Image")}: {fileImageName}
                </Typography>
              )}
            </Box>
          </Box>

            <br />
            <br />
            <LoadingButton
              type="submit"
              loading={loading}
              loadingPosition="start"
              variant="contained"
            >{t("add")}</LoadingButton>
          </form>
        </> : <Loading />}

      </Container>
    </Navbar>
  )
}

export default AddResources
